import React, { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import "./Tooltip.scss";

// SVG filter Mercury Drop — se renderiza una sola vez fuera del portal
const MercuryFilter = () => (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
            <filter id="tooltip-mercury" x="0%" y="0%" width="100%" height="100%">
                <feTurbulence type="fractalNoise" baseFrequency="0.008 0.008" numOctaves="2" seed="92" result="noise" />
                <feGaussianBlur in="noise" stdDeviation="2" result="blurred" />
                <feDisplacementMap in="SourceGraphic" in2="blurred" scale="60" xChannelSelector="R" yChannelSelector="G" />
            </filter>
        </defs>
    </svg>
);

const Tooltip = ({ content, children, triggerStyle ,className}) => {
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0, arrowLeft: "50%", placement: "top", ready: false });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);
    const hideTimer = useRef(null);

    const clearHide = () => { if (hideTimer.current) clearTimeout(hideTimer.current); };
    const scheduleHide = () => { hideTimer.current = setTimeout(() => setVisible(false), 120); };

    useLayoutEffect(() => {
        if (!visible || !triggerRef.current || !tooltipRef.current) return;

        const trigger = triggerRef.current.getBoundingClientRect();
        const tip = tooltipRef.current.getBoundingClientRect();
        const vw = window.innerWidth;
        const gap = 8;
        const arrow = 4;

        let placement = "top";
        let top = trigger.top - tip.height - arrow;
        let left = trigger.left + trigger.width / 2 - tip.width / 2;

        // Si sale por arriba, colocar abajo
        if (top < gap) {
            placement = "bottom";
            top = trigger.bottom + arrow;
        }

        // Clamp horizontal
        if (left < gap) left = gap;
        if (left + tip.width > vw - gap) left = vw - tip.width - gap;

        // La flecha siempre apunta al centro del trigger
        const arrowLeft = trigger.left + trigger.width / 2 - left;

        setPos({ top, left, arrowLeft, placement, ready: true });
    }, [visible]);

    const show = () => {
        clearHide();
        setPos(p => ({ ...p, ready: false }));
        setVisible(true);
    };

    return (
        <>
            <MercuryFilter />
            <div
                className={`tooltip-trigger ${className||""}`}
                style={triggerStyle}
                ref={triggerRef}
                onMouseEnter={show}
                onMouseLeave={scheduleHide}
            >
                {children}
                {visible && createPortal(
                    <div
                        className={`tooltip-box ${pos.placement}${pos.ready ? " ready" : ""} animate__animated animate__fadeIn`}
                        ref={tooltipRef}
                        style={{ top: pos.top, left: pos.left, "--arrow-left": `${pos.arrowLeft}px` }}
                        onMouseEnter={clearHide}
                        onMouseLeave={scheduleHide}
                    >
                        {content}
                    </div>,
                    document.body
                )}
            </div>
        </>
    );
};

export default Tooltip;
